<form name="targetForm" [formGroup]="targetForm">
    <section class="sideRight-body">

        <div id="container-header">
            <div id="contentD">
                <i class="fas fa-folder-open"></i>
            </div>

            <div id="contentE">
                <h4><b>Project Details</b></h4>
            </div>
        </div>

        <div id="container">
            <div id="contentC">
                <label>
                    <i class="fas fa-asterisk"></i> Project Number
                    <span *ngIf="f.projectNumber.errors && f.projectNumber.touched">
                        <span class="required-error" *ngIf="f.projectNumber.errors.required">
                            (required)
                        </span>
                    </span>
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors" [ngClass]="{'ng-invalid': projectNoError}"
                            type="text" formControlName="projectNumber" placeholder="Accepts numbers and letters"
                            (input)="onEditProjectData();checkProjectNumber()" (blur)="trimSpecialChar('projectNumber')"
                            (change)="checkProjectNumber()" maxlength="100" no-special-chars="<>" required>                       
                    </div>

                </label>
            </div>
        </div>

        <div class="form-error-sign error-message" *ngIf="projectNoError">
            <p>Project Number is already in use.</p>
        </div>
        <div class="form-error-sign error-message" *ngIf="f.projectNumber.errors && !f.projectNumber.errors.required">
            <p>Numbers or letters only</p>
        </div>

        <div id="container">
            <div id="contentC">
                <label>
                    <i class="fas fa-asterisk"></i> Project Name
                    <span *ngIf="f.name.errors && f.name.touched && !isProjectName">
                        <span class="required-error" *ngIf="f.name.errors.required">
                            (required)
                        </span>
                    </span>
                    <input class="black-input opposite-colors" type="text" no-special-chars="<>"
                        (input)="onEditProjectData();onProjectNameChanged();checkProjectName()" 
                        (blur)="trimSpecialChar('name');"
                        (change)="checkProjectName()" 
                        formControlName="name" maxlength="100" required>
                </label>
            </div>
        </div>
        <div class="form-error-sign error-message" *ngIf="projectNameDuplicateError">
            <p>Project Name is already in use.</p>
        </div>

        <div id="container">
            <div id="contentC">
                <label>
                    <i class="fas fa-asterisk"></i> Project type
                    <span class="required-error" *ngIf="showProjectTypeValidation">
                        (required)
                    </span>
                </label>
                <div class="input-icon-right project-type" [ngClass]="{'error-section': showProjectTypeValidation}">
                    <custom-dropdown [options]="dropdownOptions" [selectText]="addProjectSelectText"
                        (optionSelectedEvent)="onProjectTypeSelected($event)">
                    </custom-dropdown>
                </div>
            </div>
        </div>

        <div id="container">
            <div id="contentC">
                <i class="fas fa-asterisk"></i> Link Project to Entities
                <div class="radiobuttons-wrapper">
                    <div class="entity-select-container" *ngFor="let option of projectEntityAssociationOptions">
                        <label class="chkbox-container">{{option.value}}
                            <input type="radio" name="selectFlag" [checked]="option.isSelected"
                                (change)="onEntityAssociationChange(option)">
                            <span class="chk-checkmark"></span>
                            <span class="required-error"
                                *ngIf="option.id === 2 && isSpecificEntitySelected && !isProjectEntityAssociated">
                                (required)
                            </span>
                        </label>
                    </div>
                </div>
                <div class="multi-select-entity-box" *ngIf="isSpecificEntitySelected"
                    [ngClass]="{'error-section': !isProjectEntityAssociated}">
                    <ng-multiselect-dropdown style="margin-top: 0 !important;" [placeholder]="'Select entities'"
                        [settings]="dropdownSettings" [data]="legalEntities" [(ngModel)]="entityName"
                        [ngModelOptions]="{standalone: true}" (onSelect)="onEntitySelect($event)"
                        (onDeSelect)="onEntityDeSelect($event)" class="full-width">
                    </ng-multiselect-dropdown>
                </div>
            </div>
        </div>

        <div id="container">
            <div id="contentC">
                <label>
                    <i class="fas fa-asterisk"></i> Qualified Percentage
                    <span *ngIf="f.qpercentage.errors && f.qpercentage.touched">
                        <span class="required-error" *ngIf="f.qpercentage.errors.required">
                            (required)
                        </span>
                    </span><br />
                    <div class="input-icon-right">
                        <input class="black-input opposite-colors" placeholder="0" min="0" value="100" max="100"
                            (input)="onEditProjectData()" formControlName="qpercentage" type="number" required>
                        <i class="fas fa-percent"></i>
                    </div>
                </label>
            </div>
        </div>


        <div class="form-error-sign error-message" *ngIf="!f.qpercentage.valid">
            Qualified Percentage must be a number between 0-100%, and can have up to two decimal places.
        </div>

        <div id="container">
            <div id="contentC">
                <label>
                    Description
                    <textarea class="black-input opposite-colors" placeholder="A maximum of 500 characters is allowed."
                        no-special-chars="<>" (blur)="trimSpecialChar('desc');" (input)="onEditProjectData()" rows="5"
                        maxlength="500" formControlName="desc"></textarea>
                </label>
            </div>
        </div>

    </section>

    <section class="sideRight-body" *ngIf="drawerTitle === 'Delete Projects'">
        <h3>Delete projects</h3>
        <br />
        <table cellpadding="5" cellspacing="5" class="table--delete-multiple-employees"
            style="margin-bottom:5%;border-collapse:unset !important;" *ngFor="let project of projects">
            <tr *ngIf="project.projectNumber">
                <td style="width:35%;">Project Number:</td>
                <td style="width:65%;">{{project.projectNumber}}</td>
            </tr>
            <tr *ngIf="project.name">
                <td style="width:35%;">Name:</td>
                <td style="width:65%;">{{project.name}}</td>
            </tr>
            <tr *ngIf="project.desc">
                <td style="width:35%;">Description:</td>
                <td style="width:65%;">{{project.desc}}</td>
            </tr>
            <tr>
                <td style="width:35%;">Percentage:</td>
                <td style="width:65%;">{{project.qPercentage}}</td>
            </tr>
        </table>
    </section>

    <footer class="endFormSubmit info-tile">
        <button type='button' *ngIf="drawerTitle === 'Add Project'" class="btn btn-success" [disabled]="isValidForm()"
            (click)="addProjectButtonClick()">
            Add Project
        </button>
        <button class="btn kpmg-button--flat" (click)="cancelButtonClick()">
            Cancel
        </button>
    </footer>

</form>
